<div class="brm-c-accordion">
    <ng-content select="app-accordion-item"></ng-content>
</div>